import { Dialog, DialogContent } from "@/components/ui/dialog";
import { MarketIntelligencePane } from "./MarketIntelligencePane";

interface MarketIntelligenceDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Shared dialog wrapper around MarketIntelligencePane.
 *
 * Used by carrier and shipper dashboards so all three roles render the SAME
 * Market Intelligence content from MarketIntelligencePane.tsx — the single
 * source of truth for the weekly manual update.
 *
 * Broker dashboard intentionally still uses the existing center-pane swap
 * (no broker UX change).
 */
export function MarketIntelligenceDialog({ open, onOpenChange }: MarketIntelligenceDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl p-0 max-h-[85vh] overflow-hidden gap-0">
        <MarketIntelligencePane onBack={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  );
}
